// /**
//  * article模块接口列表
//  */

import { get } from '../http'; // 导入http中创建的axios实例
export const dicts = {
    getDicts(dictType) {
        return get(`${process.env.VUE_APP_BASE_API}/system/dict/data/type/${dictType}`);
    },
}